// extracted by mini-css-extract-plugin
module.exports = {"container":"Categories-module--container--37Yhk","category":"Categories-module--category--3jqbN","image":"Categories-module--image--3HKqZ"};